let serverTime: Date;

export const getServerTime = async () => {
  try {
    const response = await fetch("https://worldtimeapi.org/api/ip");
    if (!response.ok) {
      throw new Error(`Time API responded with ${response.status}`);
    }
    const data = await response.json();
    const time = new Date(data.datetime);
    if (isNaN(time.getTime())) {
      throw new Error("Invalid datetime from time API");
    }
    serverTime = time;
  } catch {
    // Time API is unreliable; fall back to the device clock
    serverTime = new Date();
  }

  return serverTime;
};
